<template>
  <v-card flat height="67vh">
    trash

  </v-card>
</template>

<script>
export default {
  name: 'TrashMediaWindow'
}
</script>
